<div #passReset class="passwordRest inputs" fxLayout="row wrap">
    <div class="closeX"><i class="flaticon-close delete" (click)="closePassReset()"></i></div>
    <div fxFlex="100" fxFlex.gt-md="18.3em" fxLayout="column">
        <div class="inputTitle">
            <span>Old Password*</span>
        </div>
        <mat-form-field appearance="outline">
            <input matInput type="text" name="old_password" type="password" [(ngModel)]="passwordObj.old_password"
                (ngModelChange)="resetOldPasswordError($event)">
        </mat-form-field>

        <div *ngIf="errorObject?.old_password?.length">
            <ul class="error">
                <li *ngFor="let item of errorObject.old_password" class="error">{{item}}</li>
            </ul>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-md="18.3em" fxLayout="column">
        <div class="inputTitle">
            <span>Enter New Password*</span>
        </div>
        <mat-form-field appearance="outline">
            <input matInput type="text" name="new_password" type="password" [(ngModel)]="passwordObj.new_password"
                (ngModelChange)="resetNewPasswordError($event)">
        </mat-form-field>

        <div *ngIf="errorObject?.new_password?.length">
            <ul class="error">
                <li *ngFor="let item of errorObject.new_password" class="error">{{item}}</li>
            </ul>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-md="18.3em" fxLayout="column">
        <div class="inputTitle">
            <span>Re-enter New Password*</span>
        </div>
        <mat-form-field appearance="outline">
            <input matInput type="text" name="new_password_confirm" type="password" [(ngModel)]="new_password_confirm"
                (ngModelChange)="resetConfirmPasswordError($event)">
        </mat-form-field>

        <div *ngIf="errorObject?.new_password_confirm?.length">
            <ul class="error">
                <li *ngFor="let item of errorObject.new_password_confirm" class="error">{{item}}</li>
            </ul>
        </div>
    </div>
    <div class="btn" fxFlex="100">
        <button mat-raised-button (click)="changeUserPassword()"> Change Password</button>
    </div>
</div>
<mat-card>
    <mat-card-content fxLayout="column">

        <mat-card-title>Password
        </mat-card-title>
        <span class="fs-14">Change your account password often to prevent unauthorized access to your
            account.</span>

        <div class="infoCard">
            <div class="passwordReset">
                <img src="assets/images/icons/shield.svg" alt="">
                <span [innerHTML]="passwordChangeMessage"></span>
                <button mat-raised-button (click)="resetPassword()"> Change Password</button>
            </div>
        </div>

        <!-- fxFlex="100" fxFlex.gt-md="33%" fxLayout="column" -->
    </mat-card-content>
</mat-card>
<mat-card>
    <mat-card-content fxLayout="column">
        <mat-card-title>Enable Two-Step Authentication
        </mat-card-title>
        <div class="infoCard">
            <div class="authentication">
                <img src="assets/images/icons/authentication.svg" alt="">
                <span>Add an extra layer of security.</span>
                <small> After you turn on 2-Step Verification, you must complete a second step to verify it’s you when
                    you sign in. To help protect your account, We will ask that you complete a specific second
                    step.</small>
            </div>
        </div>
        <!-- <div class="cardHolder">

            <mat-radio-group>
                <mat-radio-button *ngFor="let auth of authOptions" value="{{auth.name}}" color="primary">
                    <div class="Card">
                        <small *ngIf="auth.recommended"> Recommendation</small>
                        <h5>{{auth.name}}</h5>
                        <span>{{auth.details}}</span>
                        <div></div>

                    </div>
                </mat-radio-button>
            </mat-radio-group>
        </div> -->
        <ng-container *ngIf="twoFactAuthList?.results?.length > 0">
            <mat-radio-card class="cardHolder" [options]="twoFactAuthList?.results" (onDataChange)="update2FA($event)">
            </mat-radio-card>
        </ng-container>
    </mat-card-content>
</mat-card>